import type { SkinTokens } from './types';

export const DEFAULT_SKIN_TOKENS: SkinTokens = {
  theme: 'dark',
  palette: {
    background: '#09111b',
    backgroundGradient: 'radial-gradient(circle at 12% 8%, rgba(58,123,213,.32), transparent 38%), radial-gradient(circle at 88% 18%, rgba(95,80,190,.28), transparent 42%), linear-gradient(160deg, #0a141f 0%, #081018 55%, #111624 100%)',
    panel: '#17212b',
    control: '#202b36',
    overlay: '#16202b',
    primary: '#6ba7e5',
    primaryPressed: '#4c83bd',
    text: '#f7fbff',
    textSecondary: '#9aabba',
    border: '#314152',
    danger: '#ff776c',
    backdrop: 'rgba(0,0,0,.58)',
  },
  glass: {
    panelTransparency: 30,
    controlTransparency: 25,
    overlayTransparency: 15,
    blurPx: 18,
    saturation: 135,
    tintColor: '#6ba7e5',
    tintStrength: 18,
  },
  bubbles: { user: '#3f7fb8', assistant: '#243240', system: '#17212b' },
  bubbleImages: {},
  radii: { xs: 6, sm: 10, md: 14, lg: 18, full: 999 },
  shadows: { low: '0 1px 2px rgba(0,0,0,.22)', high: '0 12px 32px rgba(0,0,0,.42)' },
  typography: {
    bodyFamily: 'system-ui',
    headingFamily: 'system-ui',
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 26,
  },
  icons: { color: '#6ba7e5', strokeWidth: 1.75, activeBackground: 'rgba(107,167,229,.2)', followTheme: true },
  wallpaper: { fit: 'cover', position: 'center' },
  componentOverrides: {},
};

export function cloneDefaultSkinTokens(): SkinTokens {
  return JSON.parse(JSON.stringify(DEFAULT_SKIN_TOKENS)) as SkinTokens;
}

